import ReportConfigurationListSectionAdmin from './Core/ReportConfigurationListSectionAdmin';

const ReportConfigurationListAdmin = () => {
  return (
    <>
      <ReportConfigurationListSectionAdmin />
    </>
  );
};

export default ReportConfigurationListAdmin;
export { ReportConfigurationListAdmin };
